import { useSuspenseQuery } from '@apollo/client';
import { gql } from '@/__generated__';

export const PublicStreamPostPreviewQuery = gql(`
  query PublicStreamPostPreviewQuery($id: ID!) {
    publicStreamPostPreview(id: $id) {
      items {
        ... on StreamPost {
          ...StreamPostCardFragment
        }
      }
    }
  }
  `);

export const usePublicStreamPosts = (id: string) => {
  return useSuspenseQuery(PublicStreamPostPreviewQuery, {
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  });
};
